// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2d39B","info":"PatientInfo_info__1gS0-"};